export default "__VITE_ASSET__b9BBMj0n__"